import styled from '@emotion/styled';
import type { MicrositeVideoData } from '~/model';
import MicrositeVideo from '~/components/MicrositeVideo';
import useIsTab from '~/hooks/useIsTab';

const Section = styled.section`
	background: white;
	padding: 2rem 1.5rem 3rem;
`;

const Title = styled.h2`
	text-transform: uppercase;
	font-size: 1.5rem;
	letter-spacing: 0.2em;
	text-align: center;
	margin-bottom: 1.5rem;
`;

const Player = styled.div`
	width: 100%;
	aspect-ratio: 16 / 9;
`;

export default function VideoBlockAlpha({ title, video }: { title: string; video: MicrositeVideoData }) {
	const tab = useIsTab();

	return (
		<Section id="video">
			{!tab && <Title>{title}</Title>}
			<Player>
				<MicrositeVideo video={video} />
			</Player>
		</Section>
	);
}
